import Report from "@/components/orders/Report";
import DeductToAdminButton from "@/components/orders/DeductToAdminButton";
import { Button } from "@/components/ui/Button";
import OrderStatus from "@/components/ui/OrderStatus";
import CardImage from "@/pages/dashboard/components/CardImage";
import MoreInfoPopover from "@/pages/dashboard/components/MoreInfoPopover";
import { getTimeFromNow } from "@/utils/getTimeFromNow";
import dayjs from "dayjs";
import Link from "next/link";
import { FaRegFolderOpen } from "react-icons/fa";

export const getLastOrdersColumns = (refetchOrders, t) => [
  {
    header: t("orders_table.type"),
    minSize: 300,
    cell: ({ row: { original } }) => {
      return (
        <>
          {original?.offerName
            ? t("orders_table.recharge_balance") + ` (${original?.offerName})`
            : !original?.itemProductForActivationOnly || !original.itemActivated
              ? t("orders_table.purchase_product") +
                ` (${original?.itemProductName})`
              : original?.itemProductForActivationOnly &&
                t("orders_table.direct_recharge") +
                  ` (${original?.itemProductName})`}
        </>
      );
    },
  },
  {
    header: t("orders_table.amount"),
    accessorKey: "amount",
    cellClassName: "whitespace-nowrap",
    cell: ({ row: { original } }) => {
      return (
        original?.amount && original?.amount + " " + t("DA", { ns: "symbols" })
      );
    },
  },
  {
    header: t("orders_table.status"),
    accessorKey: "status",
    cell: ({ row: { original } }) => <OrderStatus status={original.status} />,
  },
  {
    header: t("orders_table.info"),
    accessor: "info",
    cell: ({ row: { original } }) => {
      if (original.number) {
        return original.number;
      } else if (original?.cardsNumber > 1) {
        return (
          <Link href={`/orders/items/${original?.id}`} passHref>
            <Button size="icon" variant="ghost" className="h-8 w-8">
              <FaRegFolderOpen className="text-[1.1rem]" />
            </Button>
          </Link>
        );
      } else {
        return (
          <div className="flex items-center gap-2">
            <MoreInfoPopover order={original} />

            <CardImage serial={original?.itemCode} />

            {/* {original.itemProductName.match(/ADSL|4G/) !== null && (
              <ActivateCardDialog
                orderId={original.id}
                subCategory={
                  original.itemProductName.includes("4G") ? "4G" : "Idoom"
                }
                productName={original.itemProductName}
                refetchOrders={refetchOrders}
                itemActivated={original.itemActivated}
                isForTable
              />
            )} */}
          </div>
        );
      }
    },
  },
  {
    header: t("orders_table.created_at"),
    accessorKey: "createTime",
    cellClassName: "whitespace-nowrap",
    cell: ({ row: { original } }) => {
      const createTime = dayjs(original?.createTime);
      const now = dayjs();
      const diffHours = now.diff(createTime, "hours");

      if (diffHours < 24) {
        return (
          <span>
            {getTimeFromNow(createTime)} &nbsp;
            <span className="text-muted-foreground">
              ({createTime.format("HH:mm:ss")})
            </span>
          </span>
        );
      } else {
        return createTime.format("YYYY-MM-DD HH:mm:ss");
      }
    },
  },
];

export const getOrdersColumns = (refetchOrders, t) => {
  const lastOrdersColumns = getLastOrdersColumns(refetchOrders, t);
  lastOrdersColumns.splice(-1, 0, {
    header: t("orders_table.previous_balance"),
    cell: ({ row: { original } }) => {
      return (
        <span>
          {original?.previousBalance?.toLocaleString() +
            " " +
            t("DA", { ns: "symbols" })}
        </span>
      );
    },
  });

  lastOrdersColumns.push({
    header: t("orders_table.report_issue"),
    accessor: "report",
    cell: ({ row: { original } }) => {
      return (
        <>
          <Report id={original?.id} original={original} />
        </>
      );
    },
  });

  return lastOrdersColumns;
};

export const getUserOrdersColumns = (currentUser, t, userId) => {
  const lastOrdersColumns = getLastOrdersColumns(null, t);
  lastOrdersColumns.splice(-1, 0, {
    header: t("orders_table.previous_balance"),
    cell: ({ row: { original } }) => {
      return (
        <span>
          {original?.previousBalance?.toLocaleString() +
            " " +
            t("DA", { ns: "symbols" })}
        </span>
      );
    },
  });

  if (currentUser?.user?.roles?.[0]?.name === "ROLE_ADMIN") {
    lastOrdersColumns.push({
      header: t("orders_table.actions"),
      accessor: "deduct_action",
      cell: ({ row: { original } }) => (
        <DeductToAdminButton userId={userId} orderId={original.id} />
      ),
    });
  }

  return lastOrdersColumns;
};
